export enum ChannelPartnerInvoiceStatus {
  Approved = 'Approved',
  Pending = 'Pending',
  InProgress = 'InProgress',
  Rejected = 'Rejected',
}
export default ChannelPartnerInvoiceStatus;
